"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.userGroup.list': 'Grupy Użytkowników',
    'route.userGroup.create': 'Dodaj Grupę Użytkowników',
    'route.userGroup.edit': 'Edytuj Grupę Użytkowników',
};
